import { AlloProvider, AlloV1, AlloV2, createEthersTransactionSender, createPinataIpfsUploader, createWaitForIndexerSyncTo, isChainIdSupported } from "common";
import { getConfig } from "common/src/config";
import { useEffect, useMemo, useState } from "react";
import { AlloVersionProvider } from "common/src/components/AlloVersionSwitcher";
import { useAccount } from "wagmi";
import { config, getEthersProvider, getEthersSigner } from "../../app/wagmi";
import { reconnect } from "@wagmi/core";
import { jsx as _jsx } from "react/jsx-runtime";
function AlloWrapper(_ref) {
  let {
    children
  } = _ref;
  const {
    chain,
    isConnected,
    connector
  } = useAccount();
  const [signer, setSigner] = useState();
  const [provider, setProvider] = useState();
  const [backend, setBackend] = useState(null);
  const chainID = chain === null || chain === void 0 ? void 0 : chain.id;
  useEffect(() => {
    const init = async () => {
      const s = await getEthersSigner(connector, chainID);
      const p = getEthersProvider(chainID);
      setSigner(s);
      setProvider(p);
    };
    const connect = async () => {
      await reconnect(config);
    };
    if (isConnected && chainID && connector !== null && connector !== void 0 && connector.getAccounts) init();
    if (!isConnected) connect();
  }, [chainID, isConnected, connector]);
  useEffect(() => {
    const chainIdSupported = chainID ? isChainIdSupported(chainID) : false;
    if (!isConnected || !connector || !provider || !signer || !chainID || !chainIdSupported) {
      return;
    }
    const globalConfig = getConfig();
    let alloBackend;
    if (globalConfig.allo.version === "allo-v2") {
      alloBackend = new AlloV2({
        chainId: chainID,
        transactionSender: createEthersTransactionSender(signer, provider),
        ipfsUploader: createPinataIpfsUploader({
          token: getConfig().pinata.jwt,
          endpoint: `${getConfig().pinata.baseUrl}/pinning/pinFileToIPFS`
        }),
        waitUntilIndexerSynced: createWaitForIndexerSyncTo(`${getConfig().dataLayer.gsIndexerEndpoint}/graphql`)
      });
    } else {
      alloBackend = new AlloV1({
        chainId: chainID,
        transactionSender: createEthersTransactionSender(signer, provider),
        ipfsUploader: createPinataIpfsUploader({
          token: getConfig().pinata.jwt,
          endpoint: `${getConfig().pinata.baseUrl}/pinning/pinFileToIPFS`
        }),
        waitUntilIndexerSynced: createWaitForIndexerSyncTo(`${getConfig().dataLayer.gsIndexerEndpoint}/graphql`)
      });
    }
    setBackend(alloBackend);
  }, [provider, signer, chainID, isConnected, connector]);
  const memoizedBackend = useMemo(() => backend, [backend]);
  return /*#__PURE__*/_jsx(AlloProvider, {
    backend: memoizedBackend,
    children: /*#__PURE__*/_jsx(AlloVersionProvider, {
      children: children
    })
  });
}
export default AlloWrapper;